import apiClient from '../utils/apiClient';

const device = '/device';

export const GetAllSides = async () => {
  try {
    const response = await apiClient.get(`${device}/getAll`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sides:', error);
    throw error;
  }
};

export const GetAllPorts = async () => {
  try {
    const response = await apiClient.get(`${device}/getPorts`);
    return response.data;
  } catch (error) {
    console.error('Error fetching ports:', error);
    throw error;
  }
};

export const getAllGroups = async () => {
  try {
    const response = await apiClient.get(`${device}/deviceGroups`);
    return response.data;
  } catch (error) {
    console.error('Error fetching device groups:', error);
    throw error;
  }
};

export const createDeviceGroup = async name => {
  try {
    const response = await apiClient.post(
      `${device}/deviceGroups?name=${name}`
    );
    return response;
  } catch (error) {
    console.error('Error creating device group:', error);
    throw error;
  }
};

export const updateDeviceGroup = async (id, newName) => {
  try {
    const response = await apiClient.put(`${device}/deviceGroups`, {
      id,
      name: newName,
    });
    return response;
  } catch (error) {
    console.error('Error updating device group:', error);
    throw error;
  }
};

export const deleteDeviceGroup = async id => {
  try {
    const response = await apiClient.delete(`${device}/deviceGroups?id=${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting device group:', error);
    throw error;
  }
};

export const createDevice = async (device, type) => {
  try {
    let url;
    switch (type) {
      case 'modbusTCP':
      case 'modbusRTU':
        url = `device`;
        break;
      case 'VirtualDevice':
        url = `device/Virtual`;
        break;
      default:
        throw new Error('Unsupported device type');
    }

    const response = await apiClient.post(url, device);
    return response;
  } catch (error) {
    console.error(`Error creating ${type} device:`, error);
    throw error;
  }
};

export const updateDevice = async (id, device, type) => {
  try {
    let endpoint;
    if (type === 'modbusRTU' || type === 'modbusTCP') {
      endpoint = `device/${id}`;
    } else if (type === 'VirtualDevice') {
      endpoint = `device/Virtual/?id=${id}`;
    } else {
      throw new Error('Unknown device connection type');
    }

    const response = await apiClient.put(endpoint, device);
    return response;
  } catch (error) {
    console.error(`Error updating ${type} device:`, error);
    throw error;
  }
};

export const deleteDeviceById = async (id, device) => {
  try {
    if (!device || !device.connType) {
      throw new Error('Device information is missing');
    }

    const response = await apiClient.delete(
      `device/?id=${id}&connectionType=${device.connType}`
    );
    return response.data;
  } catch (error) {
    console.error(`Error deleting ${id} device:`, error);
    throw error;
  }
};

export const exportDeviceExcel = async () => {
  try {
    const response = await apiClient.get(`${device}/exportExcel`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error('Error exporting device Excel:', error);
    throw error;
  }
};
